export default __webpack_public_path__ + "3324034623d93744c33daf740a7c5042.png";